// extracted by mini-css-extract-plugin
export var deleteModal = "_rx-0";